import { BankIcon } from '../../../icons';
import SlideoutMenu from '../../base/SlideoutMenu';
import Entity from '../../entity';

import type { EntityAvatarFragment } from '../../entity/EntityAvatar/__generated__/EntityAvatar.gql';

interface IAccountRowProps {
  financialAccount: EntityAvatarFragment & { mask: string };
  onClick?: () => void;
  caption?: string;
}

const AccountRow = ({ financialAccount, onClick, caption }: IAccountRowProps) => {
  return (
    <SlideoutMenu.Row onClick={onClick} icon={<BankIcon className="size-4.5 shrink-0" />} title="Account">
      <div className="flex min-w-0 items-center gap-2">
        <Entity.Avatar entity={financialAccount} size="xs" />
        <div className="flex min-w-0 flex-col">
          <div className="flex min-w-0 items-center gap-0.5">
            <span className="text-primary text-md min-w-0 truncate font-medium leading-[22px]">
              {financialAccount.name}
            </span>
            <span className="text-primary text-md shrink-0 font-medium leading-[22px]">
              (••{financialAccount.mask})
            </span>
          </div>
          {caption && <span className="text-tertiary self-end text-sm font-medium italic">{caption}</span>}
        </div>
      </div>
    </SlideoutMenu.Row>
  );
};

export default AccountRow;
